export enum Debtor {
    GET_DEBTORS_START = "GET_DEBTORS_START",
    GET_DEBTORS_SUCCESS = "GET_DEBTORS_SUCCESS",
    GET_DEBTORS_FAIL = "GET_DEBTORS_FAIL",

    GET_DEBTOR_BY_NUMBER_START = "GET_DEBTOR_BY_NUMBER_START",
    GET_DEBTOR_BY_NUMBER_SUCCESS = "GET_DEBTOR_BY_NUMBER_SUCCESS",
    GET_DEBTOR_BY_NUMBER_FAIL = "GET_DEBTOR_BY_NUMBER_FAIL",
}